import Swal from 'sweetalert2';
import adminTranslations from './adminTranslations';

const t = (key: string): string => {
  const lang = (localStorage.getItem('locale') as 'en' | 'ar') || 'en';
  return adminTranslations[lang]?.[key] || adminTranslations.en[key] || key;
};

export const confirmDelete = async (title: string = t('Are you sure?'), text: string = t("You won't be able to revert this!")): Promise<boolean> => {
  const result = await Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: t('Yes, delete it!'),
    cancelButtonText: t('Cancel'),
  });

  return result.isConfirmed;
};

export const confirmLogout = async (): Promise<boolean> => {
  const result = await Swal.fire({
    title: t('Are you sure?'),
    text: t('You want to logout'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: t('Yes, logout!'),
    cancelButtonText: t('Cancel'),
  });

  return result.isConfirmed;
};

export const confirmAction = async (title: string, text: string, confirmText: string = t('Yes')): Promise<boolean> => {
  const result = await Swal.fire({
    title,
    text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#6c757d',
    confirmButtonText: confirmText,
    cancelButtonText: t('Cancel'),
  });

  return result.isConfirmed;
};
















